import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './store/auth/useAuth';
import { VideoProvider } from './store/video/useVideo';
import { UserPreferencesProvider } from './store/userPreferences/useUserPreferencesContext';
import App from './components/App/App';

ReactDOM.render(
  <AuthProvider>
    {({ user }) => (
      <VideoProvider>
        <UserPreferencesProvider user={user}>
          <App />
        </UserPreferencesProvider>
      </VideoProvider>
    )}
  </AuthProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
